import React from 'react';
import { motion } from 'framer-motion';
import { Calendar, MessageCircle } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto mb-12" data-id="element-94">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} className="relative rounded-3xl overflow-hidden bg-gradient-to-br from-dark-card to-black border border-gold/20 p-10 md:p-16 text-center shadow-[0_0_50px_rgba(201,168,76,0.1)]" data-id="element-95">
        {/* Background glow */}
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(201,168,76,0.1)_0%,transparent_70%)]" data-id="element-96" />

        <div className="relative z-10 max-w-3xl mx-auto" data-id="element-97">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-98">
            ¿Listo para tu próximo corte?
          </h2>

          <p className="text-lg md:text-xl text-gray-300 mb-10" data-id="element-99">
            Reservá tu horario disponible en la agenda online.{' '}
            <br className="hidden md:block" data-id="element-100" />
            Para cursos, consultá cupos por WhatsApp.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6" data-id="element-101">
            <a href="#sucursales" className="flex items-center justify-center gap-2 bg-gold hover:bg-gold-light text-dark font-bold py-4 px-8 rounded-full w-full sm:w-auto transition-all duration-300 transform hover:-translate-y-1 shadow-[0_0_20px_rgba(201,168,76,0.3)]" data-id="element-102">
              <Calendar size={20} data-id="element-103" />
              <span data-id="element-104">Reservar turno</span>
            </a>

            <a href="https://wa.me/59893472053" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 bg-transparent border border-white/30 hover:border-gold text-white hover:text-gold font-semibold py-4 px-8 rounded-full w-full sm:w-auto transition-all duration-300" data-id="element-105">
              <MessageCircle size={20} data-id="element-106" />
              <span data-id="element-107">Consultar cursos</span>
            </a>
          </div>
        </div>
      </motion.div>
    </section>;
}